import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { HttpService } from 'src/app/services/http.service';
import { FeatureFlag } from 'src/app/bo/featureFlag';
import { Site } from 'src/app/bo/site';
import {
  AREA_FEATURE_NAME,
  getOrganizationIdsFromSites,
  isAreaEnabledForUser,
} from './landingRedirectGuard';

export const AreaAccessGuard: CanActivateFn = () => {
  const http = inject(HttpService);
  const router = inject(Router);

  return forkJoin({
    flags: http.get<FeatureFlag[]>('FeatureFlag').pipe(catchError(() => of([] as FeatureFlag[]))),
    sites: http.get<Site[]>('Sites/Active').pipe(catchError(() => of([] as Site[]))),
  }).pipe(
    map(({ flags, sites }) => {
      const flag = flags.find(f => f.featureName === AREA_FEATURE_NAME);
      const organizationIds = getOrganizationIdsFromSites(sites);

      return isAreaEnabledForUser(flag, organizationIds) ? true : router.parseUrl('/');
    }),
  );
};
